module.exports = __webpack_public_path__ + "img/59.f2e8c7f2.jpg";